export default __webpack_public_path__ + "static/media/objtop.a9745e9a.jpg";